import script from "./Bank.vue?vue&type=script&setup=true&lang=ts"
export * from "./Bank.vue?vue&type=script&setup=true&lang=ts"

import "./Bank.vue?vue&type=style&index=0&id=403b0f8a&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-403b0f8a"]])

export default __exports__